import * as React from "react";
import { useState } from "react";
import { Link } from "@ludens-reklame/rubics-v3-sdk/link/types";
import { Image } from "@ludens-reklame/rubics-v3-sdk/file/types";
import { createEditableProps } from "@ludens-reklame/rubics-v3-react/util/fns";
import {
  Constrainer,
  HorizontalSpacer,
  VerticalSpacer,
} from "../../internal-components/Layout.js";
import { createImageProps } from "../../hooks/useImageProps.js";
import { createLinkProps } from "../../hooks/useLinkProps.js";
import { chevron } from "../../icons/index.js";
import {
  MarketsLayout,
  MarketsBody,
  MarketsTitle,
  MarketsLinks,
  MarketsLink,
  MarketsMedia,
} from "./styles.js";
import type { BackgroundColor } from "../../types/theme.js";

export interface MarketsItem {
  link?: Link;
  image?: Image;
}

export interface Props {
  title?: string;
  links?: MarketsItem[];
  backgroundColor?: BackgroundColor;
}

export const Markets: React.FC<Props> = ({
  title,
  links = [],
  backgroundColor,
}) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const validLinks = links.filter((item) => item.link?.url);

  if (!title && validLinks.length === 0) return null;

  const activeImage =
    (activeIndex !== null && validLinks[activeIndex]?.image) ||
    validLinks[0]?.image;

  return (
    <VerticalSpacer>
      <HorizontalSpacer>
        <Constrainer>
          <MarketsLayout $bg={backgroundColor}>
            <MarketsBody>
              {title && (
                <MarketsTitle {...createEditableProps("text", "title")}>
                  {title}
                </MarketsTitle>
              )}
              {validLinks.length > 0 && (
                <MarketsLinks>
                  {validLinks.map((item, i) => (
                    <li key={i}>
                      <MarketsLink
                        {...createLinkProps(item.link!)}
                        onMouseEnter={() => setActiveIndex(i)}
                        onMouseLeave={() => setActiveIndex(null)}
                        onFocus={() => setActiveIndex(i)}
                        onBlur={() => setActiveIndex(null)}
                      >
                        {chevron}
                        <span>{item.link!.title}</span>
                      </MarketsLink>
                    </li>
                  ))}
                </MarketsLinks>
              )}
            </MarketsBody>
            {activeImage && (
              <MarketsMedia>
                <img
                  {...createImageProps(activeImage, { width: 800 }, "lazy")}
                />
              </MarketsMedia>
            )}
          </MarketsLayout>
        </Constrainer>
      </HorizontalSpacer>
    </VerticalSpacer>
  );
};
